export const adminUserStatuses = ['provisioned', 'active', 'disabled'];
const iso = (value) => typeof value === 'string' && !Number.isNaN(Date.parse(value));
export function isAdminUserSummary(value) {
    if (!value || typeof value !== 'object')
        return false;
    const user = value;
    return (typeof user.id === 'string' &&
        typeof user.email === 'string' &&
        typeof user.displayName === 'string' &&
        adminUserStatuses.includes(user.status) &&
        Number.isInteger(user.version) &&
        (user.version ?? 0) > 0 &&
        Array.isArray(user.roles) &&
        user.roles.every((item) => typeof item === 'string') &&
        Array.isArray(user.permissions) &&
        user.permissions.every((item) => typeof item === 'string') &&
        (user.lastAccessAt === null || iso(user.lastAccessAt)) &&
        iso(user.createdAt) &&
        iso(user.updatedAt) &&
        (user.deactivationReason === null || typeof user.deactivationReason === 'string'));
}
export function isAdminUsersListResponse(value) {
    if (!value || typeof value !== 'object')
        return false;
    const response = value;
    return (Array.isArray(response.items) &&
        response.items.every(isAdminUserSummary) &&
        Number.isInteger(response.page) &&
        Number.isInteger(response.pageSize) &&
        Number.isInteger(response.total) &&
        Number.isInteger(response.totalPages));
}
export function isAdminUserDetailResponse(value) {
    return Boolean(value &&
        typeof value === 'object' &&
        isAdminUserSummary(value.user));
}
